export default function HeartIcon({ filled = false, onClick, className = "" }) {
  return (
    <button 
      className={`heart-icon-btn ${className}`}
      onClick={onClick}
      aria-label={filled ? "Remove from favourites" : "Add to favourites"}
      title={filled ? "Remove from favorites" : "Add to favorites"}
      type="button"
    >
      <svg
        viewBox="0 0 24 24"
        width="20"
        height="20"
        fill={filled ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    </button>
  );
}
